const $ = require('jquery');
import run from '../../utilities/run';
import QuickBtnGroup from "../../components/QuickBtnGroup/QuickBtnGroup";
import {isPresent} from "../../utilities/general";
import {setOptionsForSelect} from "../../utilities/selectorHelpers";
import typeAheadSource from "../../utilities/typeAheadSource";
import _ from "underscore";
import EditChecker from '../../components/EditChecker/EditChecker';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";
import render from "../../utilities/render";
import {instantiateSelect2} from "../../utilities/select2able";

const attributeRowHtml = require("./html/attributeRow.html");
const conditionRowHtml = require("./html/conditionRow.html");

run("#rule-disp-merch-config-div", ()=>{  
  const mainEl = $("#rule-disp-merch-config-div");
  const productLookUpURL = mainEl.data('product-lookup-url');
  const productSkuTypeAhead = mainEl.find("#product-sku-typeahead");
  const attribMaxReachedError = mainEl.find(".attrib-max-reached-error"); 
  const conditionMaxReachedError = mainEl.find(".condition-max-reached-error");  
  const rule = mainEl.data("rule");
  const ruleOutputs = mainEl.data("rule-outputs");
  const evaluator = mainEl.find('#select-an-evaluator');
  const evaluatorValue = mainEl.find('#select-an-evaluator-value');
  const isDuplicate = mainEl.data("duplicate-flag");
  const costRetailBtnGroupEl = mainEl.find(".cost-retail-toggler");
  const costRetailBtnGroup = new QuickBtnGroup(costRetailBtnGroupEl, {distributeWidth: true});
  costRetailBtnGroup.init();
  let isEdit = false;	

  attachWizard(mainEl);
  setupEditChecker();
  setWidgets();
  if(rule != "" && rule.cbrId > 0) {
    isEdit = true;
  }  

  function setWidgets() {    
    instantiateSkuTypeAhead();  
  }

  function getSelectedValuesOfSelect2ById(id){
    let dataText="";
    $(`#${id} option:selected`).each(function () {
      let $this = $(this);
      if($.inArray($this.text(), listBuild)==-1){
        listBuild.push($this.text());
      }
    });

    for(let i=0; i<listBuild.length; i++){
      if(!dataText.includes(listBuild[i]) && i<listBuild.length-1){
        dataText = dataText.concat(listBuild[i].concat(", "));
      }else{
        dataText = dataText.concat(listBuild[i].concat(" "));
      }
    }
    return dataText;
  }

  function instantiateSkuTypeAhead() {
      const select2AjaxDefaults = {
        dataType: 'json',
        delay: 250,
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data,
            pagination: {
              more: (params.page * 20) < data.total_count
            }
          };
        },
        cache: true
    };
  
  productSkuTypeAhead.select2({
    placeholder: "Begin typing a SKU to add to this order",
    allowClear: true,
    ajax: {
      ...select2AjaxDefaults,
      url: productLookUpURL,
      cache: false,
      data: configureDataCallback({
          paramKey: 'likeSku'
      })
    },
    minimumInputLength: 3
  });

  function configureDataCallback({paramKey}) {
      return function(params){
        return {
          [paramKey] : params.term
        };
      };
  }
}

  $(document).on('change', 'select', function (e) {
      const attr = this.id;
      const indexId = attr.substring(attr.length - 1);
      if(attr.startsWith('attributeName_')) {
        if(this.value == '') {
          $(".attribute-row").find("#attributeValue_"+indexId).val("");
        }
      }
  });

  $(".addAttribButton").on("click", function (e, key, value, rowIdx) {
      e.preventDefault();
      const numOfAttribRows = $(".attribute-row").length;
      if(numOfAttribRows < 8) {
        const ruleInclAttributesRowClass = mainEl.find(".rule-attrib-row-div");
        const ruleInclAttributes = mainEl.data("rule-incl-attribues-from-server");
        const attributeRow = render(attributeRowHtml,{
          index: (rowIdx ? rowIdx : numOfAttribRows + 1),
          attributesHtml: renderAttributesHTML(ruleInclAttributes,key)
        });
        ruleInclAttributesRowClass.append(attributeRow);
      } else{          
        attribMaxReachedError.show();
      } 
      instantiateSelect2($('.select2-select'));
    });

  function renderAttributesHTML(ruleInclAttributes, key){
    if(ruleInclAttributes != null){
      const html = '<option></option><option value="{%-value%}" {%- selected %} >{%-display%}</option>';
      let optionHtml = ruleInclAttributes.map((row) => {
          return render(html, {
              value: row.cdmValue,
              selected: getselectedValue(row.cdmValue, key),
              display: row.cdmMeaning
          })
      });
      return optionHtml.join('');
    }
  }

  function getselectedValue(value, key) {
    if (value == key) {
      return "selected";
    }
    else {
      return "";
    }
  }
  $(".addConditionButton").on("click", function (e, condition, disposition, vas) {
      e.preventDefault();
      const numOfConditionRows = $(".condition-row").length; 
      const ruleInclConditions = mainEl.data("rule-incl-conditions-from-server");
      const ruleIncConditionRowClass = mainEl.find(".rule-condition-row-div");                    
      const ruleInclDispositions = mainEl.data("rule-incl-dispositions-from-server");
      const ruleInclVas = mainEl.data("rule-incl-vas-from-server");
      
      if(numOfConditionRows < ruleInclConditions.length) {          
        const conditionRow = render(conditionRowHtml,{
              output: (numOfConditionRows + 1 == 1) ? (numOfConditionRows + 1 + '*') : (numOfConditionRows + 1), 
              index: numOfConditionRows + 1, 
              conditionHtml: renderConditionHTML(ruleInclConditions, condition),
              dispositionHtml: renderDispositionHTML(ruleInclDispositions, disposition),
              vasHtml: renderVasHTML(ruleInclVas, vas)
        });
        ruleIncConditionRowClass.append(conditionRow);
      } else {      
        conditionMaxReachedError.text('No more conditions can be added.');
        conditionMaxReachedError.show();
      }
      instantiateSelect2($('.select2-select'));
  });
  
  function renderConditionHTML(ruleInclConditions, condition){
    if(ruleInclConditions != null){
      const html = '<option></option><option value="{%-value%}" {%- selected %} >{%-display%}</option>';
      return ruleInclConditions.map((row) => {
          return render(html, {
              value: row.cdmValue,
              selected: getselectedValue(row.cdmValue, condition),
              display: row.cdmMeaning
          })
      }) .join('');
    }    
  }

  function renderDispositionHTML(ruleInclDispositions, disposition){
    if(ruleInclDispositions != null){
      const html = '<option></option><option value="{%-value%}" {%- selected %} >{%-display%}</option>';
      return ruleInclDispositions.map((row) => {
          return render(html, {
              value: row.cdmValue,
              selected: getselectedValue(row.cdmValue, disposition),
              display: row.cdmMeaning
          })
      }) .join('');
    }    
  }

  function renderVasHTML(ruleInclVas, vas){
    if(ruleInclVas != null){
      const html = '<option></option><option value="{%-value%}" {%- selected %} >{%-display%}</option>';
      return ruleInclVas.map((row) => {
          return render(html, {
              value: row.cdmValue,
              selected: getselectedValue(row.cdmValue, vas),
              display: row.cdmMeaning
          })
      }) .join('');
    }    
  }
  if (!isEdit) {
    $(".addConditionButton").trigger("click");
  }
  populateEditDuplicateForm();  
  function populateEditDuplicateForm() {
    if(isEdit) {
      if(!isDuplicate) {
          $("#return-rule-name").val(rule.cbrName);
          $("#return-rule-description").val(rule.cbrDescription);
          $("#cbrId").val(rule.cbrId);
      }
      let conditions = rule.cmrRuleConditions;
      let attributeIndex = 0;
        for (let i=0;i<conditions.length;i++) {
          if(conditions[i].crcName === "SKU" ) {
            let params = conditions[i].cmrRuleParams;
            if(params) {
              let selectedValues = new Array();
              for (let j=0;j<params.length;j++) {
                selectedValues[j] = params[j].crpValue;
              }
             $("#productsInOrder").val(selectedValues);
             const relatedSelectPillsArray = _(params).pluck("crpValue");
             setOptionsForSelect({
                selectElement: productSkuTypeAhead,
                list: params,
                valueDataKey: "crpValue",
                textDataKey: "crpValue",
                initialSelectValue: relatedSelectPillsArray
              }); 
            }				  
          } else if (conditions[i].crcName === "Item Cost" || conditions[i].crcName === "Item Retail"  ) {
              let params = conditions[i].cmrRuleParams;
              if(params) {
                  for (let j=0;j<params.length;j++) {
                      costRetailBtnGroup.activateBtnViaKey(params[j].crpKey);
                      evaluator.val(conditions[i].crcOperator);
                      evaluatorValue.val(params[j].crpValue);
                  }
              }
          } else {
              let params = conditions[i].cmrRuleParams;
              if(params) {
                attributeIndex = attributeIndex + 1;
                for (let j=0;j<params.length;j++) {
                  $(".addAttribButton").trigger("click", [conditions[i].crcName, params[j].crpValue, attributeIndex]);
                  $("#attributeValue_"+attributeIndex).val(params[j].crpValue);
                }
              }
          }
        }
        if (ruleOutputs) {
          for (let i=0;i<ruleOutputs.length;i++) {
            $(".addConditionButton").trigger("click", [ruleOutputs[i].condition, ruleOutputs[i].disposition ,ruleOutputs[i].vas]);
          }
        }
    }
  }
  $(document).ready(function (){
    if(isEdit) {
      let dateRangeStart = $("#rule-disp-merch-config-div").find(".date-range-datepicker-start");
      let dateRangeEnd = $("#rule-disp-merch-config-div").find(".date-range-datepicker-end");
      dateRangeStart.val(rule.cbrEffectiveStartDate);
      dateRangeEnd.val(rule.cbrEffectiveEndDate);
    }
  });
}); // end run

function setupEditChecker(){
  EditChecker.bindNavigation();
  EditChecker.bindChangeListener("#rule-disp-merch-config-div");
  EditChecker.bindCancelButton(".return-rule-cancel-btn");
}

function attachWizard(mainEl) {
  const submitRuleURL = mainEl.data("submit-return-rule");

  const submitModalTitleTxt = mainEl.data("submit-modal-title-txt");
  const submitModalBodyTxt = mainEl.data("submit-modal-body-txt");
  const submitModalBtnTxt = mainEl.data("submit-modal-btn-txt");

  const doc = $(document);

  const validator = $("#rule-disp-merch-config-div").validate({
    errorPlacement: function(error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }
  });

  validator.settings.ignore = ":disabled,:hidden";
  $(".save-new-return-rule-btn").on("click", function(e) {      
    e.preventDefault();
    mainEl.find(".attrib-max-reached-error").hide();
    mainEl.find(".condition-max-reached-error").hide(); 
    
    let isValid = false;

    const prodSku = mainEl.find("#product-sku-typeahead");    
    const attribNameArr = getArr(".attribute-row", "#attributeName_");
    const attribValArr = getArr(".attribute-row", "#attributeValue_");

    if(prodSku.val().length == 0 && _.compact(attribNameArr).length == 0) {
      mainEl.find(".incl-error").show();
      isValid = true;      
    } else {
      mainEl.find(".incl-error").hide();
    }

    attribValArr.forEach(function nullCheck(item, index) {      
      let j = index +1;

      if(item == '' && mainEl.find("#attributeName_"+j).val() != '') { 
        mainEl.find(".attrib-val-error_"+j).show();
        isValid = true;
      } else if(item != '' && mainEl.find("#attributeName_"+j).val() == '') {  
        mainEl.find(".attrib-name-error_"+j).show();
        isValid = true;
      } else {
        mainEl.find(".attrib-name-error_"+j).hide();   
        mainEl.find(".attrib-val-error_"+j).hide();
      }
    });

    if(hasDup(attribNameArr)) {
      mainEl.find(".attrib-max-reached-error").text("Please fix the duplicate attributes.");
      mainEl.find(".attrib-max-reached-error").show();
      isValid = true;
    }

    const evalId = mainEl.find("#select-an-evaluator");
    const evalValue = mainEl.find("#select-an-evaluator-value");

    if(evalId.val() != '' && evalValue.val() == '') {
      mainEl.find(".eval-error").show();
      isValid = true;      
    } else {
      mainEl.find(".eval-error").hide();
    }

    const conditionArr = getArr(".condition-row", "#condition_");
    const dispositionArr = getArr(".condition-row", "#disposition_");
    const vasArr = getArr(".condition-row", "#vas_");

    conditionArr.forEach(function firstCondCheck(item, index) {
      if(index+1 == 1) {   
          if(item == '') {
            mainEl.find(".cond-sel-error_1").show();
            mainEl.find(".disp-sel-error_1").show();
            isValid = true;
          } else {
            mainEl.find(".cond-sel-error_1").hide();
            mainEl.find(".disp-sel-error_1").hide();
          }
      }
    });

    if(hasDup(conditionArr)) {      
      mainEl.find(".condition-max-reached-error").text("Please fix the duplicate Conditions.");
      mainEl.find(".condition-max-reached-error").show();      
      isValid = true;
    }

    dispositionArr.forEach(function nullCheck(item, index) {
      let k = index +1;
      if(k == 1 && item == '') {
          mainEl.find(".disp-sel-error_"+k).show();
          isValid = true;
      } else {
          if(item == '' && mainEl.find("#condition_"+k).val() != '') {       
             mainEl.find(".disp-sel-error_"+k).show();
             isValid = true;
          } else {
            mainEl.find(".disp-sel-error_"+k).hide();
          }  
      }      
    });
    
    if(validator.elements().valid()) {
      const startDate = $("#rule-disp-merch-config-div").find(".date-range-datepicker-start").val();
      const endDate = $("#rule-disp-merch-config-div").find(".date-range-datepicker-end").val();

      if(startDate != null && endDate != null) {
        if(endDate < startDate) {
          mainEl.find(".date-error").text("End Date should be greater than Start Date.");
          mainEl.find(".date-error").show();
          isValid = true;
        }
      }

      if(isValid) {
        return false;
      }

      const submitModalFlow = new SubmitModalFlow({
        confirmModalTitle: submitModalTitleTxt,
        confirmModalBody: `<div class="q-pad-all-xl">${submitModalBodyTxt}</div>`,
        confirmModalBtnText: submitModalBtnTxt,

        onConfirmClick: function() {
          submitModalFlow.showLoadingModal();
          submitRule({url: submitRuleURL, success: submitRuleSuccess, error: submitRuleError});

          function submitRule({url, success, error}) {
            $.ajax({
              data:  $('#rule-disp-merch-config-div').serialize() + "&startDate="+startDate + "&endDate="+endDate + 
              "&attribNameArr="+attribNameArr + "&attribValArr="+attribValArr+"&conditionArr="+conditionArr + 
              "&dispositionArr="+dispositionArr +"&vasArr="+vasArr,
              url: url,
              dataType:'JSON',
              type: 'POST',
              success: success,
              error: error
            });
          }

           function submitRuleSuccess(cbrId) {            
            if(cbrId > 0){
              EditChecker.setPageClean();              
              const ruleDetailUrl = mainEl.data("rule-details-url");
              submitModalFlow.showSuccessModal();
              setTimeout(function() {
                location.href = `${ruleDetailUrl}&cbrId=${cbrId}`;
              }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
            } else {
              submitModalFlow.showFailureModal();
            }
          }

          function submitRuleError() {       
            submitModalFlow.hideAllModals();
          }
        }
      });
      submitModalFlow.init();
      submitModalFlow.showConfirmModal();
    }

    function getArr(div, element) {
      const len = $(div).length;
      const arr = [];            
      for(let i = 1; i <= len; i++) {
            arr.push($(element+i).val());
      }
      return arr;
    }

    function hasDup(srcArr) {
      let remDup = (arrArg) => arrArg.filter((elem, pos, arr) => arr.indexOf(elem) == pos);
      const tempArr = remDup(srcArr);

      if(_.compact(srcArr).length == 0) {
        return false;
      }
      if(_.compact(srcArr).length == tempArr.length) {
        if(srcArr.includes('')) {
          return true;
        } else {
         return false;
        }
      } else if(_.compact(srcArr).length > tempArr.length) {
        return true;
      }
    }
  });

  doc.on('click', '#rule-disp-merch-config-div', handleClick);
  function handleClick(e){
    EditChecker.setPageDirty();
    e.preventDefault();
  }
  
} // end attachwizard



// WEBPACK FOOTER //
// ./src/pages/createDispositionRule/createEditDispositionRule.js